import { Modal } from "antd";
import { formatData, formatMoney } from "../../../../utils/functions-helper";

type ModalProps = {
  open: boolean;
  data: {
    ID: number;
    Procedimento: string;
    Valor: number;
    Paciente: string;
    Data: string;
  };
  onOk: () => void;
  onCancel: () => void;
};

const ModalExclusao = ({ open, data, onOk, onCancel }: ModalProps) => {
  return (
    <Modal
      title="Confirmar exclusão"
      open={open}
      onOk={onOk}
      okText="Excluir"
      cancelText="Cancelar"
      onCancel={onCancel}
    >
      <h3>Deseja realmente excluir este procedimento?</h3>
      <p>
        <strong>Procedimento:</strong> {data.Procedimento}
      </p>
      <p>
        <strong>Data de Realizaçao:</strong> {formatData(data.Data)}
      </p>
      <p>
        <strong>Paciente:</strong> {data.Paciente}
      </p>
      <p>
        <strong>Valor:</strong> R$ {formatMoney(data.Valor)}
      </p>
    </Modal>
  );
};

export default ModalExclusao;
